import React from 'react';
import PropTypes from 'prop-types';
import TemplateHeader from './template-header';
import TemplateBody from './template-body';
import ConsertFormManagementComponent from '../../consent/consent-form-management';

const GenericTemplateManagementComponent = ({
  headerButtonText,
  headerDescription,
  headerTitle,
  onCreateTemplate,
  noItemsMessage,
  templateType,
  onEditTemplate,
  onDeleteTemplate,
  deleteTemplateError,
  deleteTemplateLoading,
  showConsentComponent,
}) => {
  if (showConsentComponent) {
    return <ConsertFormManagementComponent />;
  }
  return (
    <>
      <TemplateHeader
        buttonText={headerButtonText}
        description={headerDescription}
        onCreateTemplate={onCreateTemplate}
        title={headerTitle}
      />
      <TemplateBody
        noItemsMessage={noItemsMessage}
        templateType={templateType}
        onEditTemplate={onEditTemplate}
        onDeleteTemplate={onDeleteTemplate}
        deleteTemplateError={deleteTemplateError}
        deleteTemplateLoading={deleteTemplateLoading}
      />
    </>
  );
};

GenericTemplateManagementComponent.propTypes = {
  headerButtonText: PropTypes.string.isRequired,
  headerDescription: PropTypes.string.isRequired,
  headerTitle: PropTypes.string.isRequired,
  onCreateTemplate: PropTypes.func.isRequired,
  noItemsMessage: PropTypes.string.isRequired,
  templateType: PropTypes.string.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
  onDeleteTemplate: PropTypes.func.isRequired,
  deleteTemplateError: PropTypes.bool.isRequired,
  deleteTemplateLoading: PropTypes.bool.isRequired,
  showConsentComponent: PropTypes.bool.isRequired,
};

export default GenericTemplateManagementComponent;
